/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef } from "react"
import Translate from "@service/Translate";
import Button from "@components/general/form/Button";
import Icon from "@components/general/Icon";
import { IContactPoint } from "@common/models/CMS";
import { FeedBackStatus, IFeedback } from "@common/models";

interface IFeedbackConfirmedItemsProps {
    contactPointRes: IContactPoint[];
    comment: IFeedback;
    onRemoveComment: (comment: IFeedback) => void;
    onModifyComment: (comment: IFeedback) => void;
}

export const FeedbackConfirmedItems: FC<IFeedbackConfirmedItemsProps> = ({ contactPointRes, comment, onRemoveComment, onModifyComment }) => {
    const { tr } = Translate;
    const feedbackCommentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (feedbackCommentRef && feedbackCommentRef.current && feedbackCommentRef.current.getBoundingClientRect().height > 56)
            feedbackCommentRef.current.classList.add('show');
    }, [feedbackCommentRef])

    const onFeedbackCommentMoreBtnClick = () => {
        if (feedbackCommentRef && feedbackCommentRef.current)
            feedbackCommentRef.current.classList.remove('show');
    }

    return (
        <div id="feedbackConfirmedItems" className="feedback-confirmed-items">
            <div className="flex flex-center justify-between issue-tracking">
                <div className="issue-title">
                    <span>{contactPointRes?.find(c => c.code?.code === comment?.typeId?.toString())?.displayText || ""} </span>
                    <span className="en">({comment.referenceId})</span>
                </div>
                {
                    comment.status === FeedBackStatus.ToDo ? <div className="button-action flex">
                        <Icon
                            name="icon-edit"
                            color="grey"
                            size="20px"
                            onClick={() => onModifyComment(comment)}
                        />
                        <Icon
                            name="icon-delete"
                            color="grey"
                            size="20px"
                            onClick={() => onRemoveComment(comment)}
                        />
                    </div>
                        : <div className={`feedback-status-${String(FeedBackStatus[comment.status as number]).toLowerCase()}`}>
                            {tr(`feedback_status_${String(FeedBackStatus[comment.status as number]).toLowerCase()}`)}
                        </div>
                }
            </div>
            <div ref={feedbackCommentRef} className="comment fade">
                {comment.description}
                <Button
                    className="show-more flex"
                    color="blue"
                    width="auto"
                    height="20px"
                    text={tr("more_btn_etc")}
                    onClick={onFeedbackCommentMoreBtnClick}
                />
            </div>
        </div>
    )
}